import type { ApiResponse } from "@/types/apiResponse";
import type { CompanyUser } from "../types"
import { apiClient } from "../../../lib/apiClient";

const fetchCompanies = async (): Promise<ApiResponse<CompanyUser[]>> => {
	return apiClient<ApiResponse>('/v1/empresas', {
		method: "GET"
	});
};

export default fetchCompanies;